// Preset "vibes" the patient can pick from on the dashboard.
// Kept as its own module so both the picker (CircleHome) and the vibe
// badge (CircleInfoDialog) stay in sync — the badge detects a saved
// preference by matching `label` inside the free-text guidance field.
export const CARE_PREFERENCES = [
  { emoji: '🎉', label: 'The more the merrier!' },
  { emoji: '🤫', label: "Quiet and private. Please don't drop by." },
  { emoji: '💬', label: 'Text is best.' },
  { emoji: '🎁', label: 'Gift card girlie.' },
  { emoji: '🪿', label: 'Grumpy Goose.' },
  { emoji: '🙏', label: 'Jesus take the wheel.' },
  { emoji: '☕', label: 'I run on coffee and data.' },
  { emoji: '🙅', label: 'No input, please.' },
  { emoji: '🍿', label: 'Snacks are always welcome.' },
];

// Given a free-text preferences string, return the ordered list of
// preset entries the patient has selected. Used for the Squad-view badge.
export const detectPreferences = (text) => {
  if (!text) return [];
  return CARE_PREFERENCES.filter((p) => text.includes(p.label));
};
